<!--
<template>
  <section class="section4">
    <div class="section4-header text-center animated slide-left delay-0">
      <span class="badge">Nos Clients</span>
      <h2 class="title">Quelques Entités Avec Lesquelles Nous Avons Travaillé :</h2>
      <div class="underline"></div>
    </div>

    <div class="logo-grid">
      <div
        class="logo-card animated"
        v-for="(logo, index) in logos"
        :key="index"
        :class="getAnimationClass(index)"
      >
        <img :src="logo.src" :alt="logo.alt" class="logo-img" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Section4View',
  data() {
    return {
      logos: [
        { src: require('@/assets/section4/mtn.jpg'), alt: 'MTN' },
        { src: require('@/assets/section4/momo.jpg'), alt: 'MTN MoMo' },
        { src: require('@/assets/section4/glo.jpg'), alt: 'Glo' },
        { src: require('@/assets/section4/adb.jpg'), alt: 'ADB' },
        { src: require('@/assets/section4/vodafone_cash.jpg'), alt: 'Vodafone Cash' },
        { src: require('@/assets/section4/vodafone.jpg'), alt: 'Vodafone' },
        { src: require('@/assets/section4/airteltigo.jpg'), alt: 'AirtelTigo' },
        { src: require('@/assets/section4/more.jpg'), alt: 'Over 200 Entities' },
      ]
    };
  },
  methods: {
    getAnimationClass(index) {
      const isLeft = index % 4 < 2; // colonnes 0 & 1 à gauche, 2 & 3 à droite
      return isLeft ? `slide-left delay-${index}` : `slide-right delay-${index}`;
    }
  }
};
</script>
-->
<!--
<template>
  <section class="section4" ref="sectionRef">
    <div class="section4-header text-center" :class="{ 'animated slide-left delay-0': isVisible }">
      <span class="badge">Nos Clients</span>
      <h2 class="title">Quelques Entités Avec Lesquelles Nous Avons Travaillé :</h2>
      <div class="underline"></div>
    </div>

    <div class="logo-grid">
      <div
        class="logo-card"
        v-for="(logo, index) in logos"
        :key="index"
        :class="[{ 'animated': isVisible }, getAnimationClass(index)]"
      >
        <img :src="logo.src" :alt="logo.alt" class="logo-img" />
      </div>
    </div>
  </section>
</template>
-->
<template>
  <section class="section4">
    <div class="section4-header text-center" ref="headerRef">
      <span class="badge bg-primary fs-2" :class="{ 'animated slide-left': headerVisible }">Nos Clients</span>
      <h2 class="title" :class="{ 'animated slide-left delay-1': headerVisible }">Quelques Entités Avec Lesquelles Nous Avons Travaillé :</h2>
      <div class="underline" :class="{ 'animated slide-left delay-2': headerVisible }"></div>
    </div>

    <div class="logo-grid">
      <div
        v-for="(logo, index) in logos"
        :key="index"
        :ref="el => { logoRefs[index] = el }"
        class="logo-card"
        :class="{
          'animated': logoVisible[index],
          [getAnimationClass(index)]: logoVisible[index]
        }"
      >
        <img :src="logo.src" :alt="logo.alt" class="logo-img" />
      </div>
    </div>
  </section>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useInView } from '@/composables/useInView.js'

export default {
  name: 'Section4View',
  setup() {
    const { isVisible: headerVisible, target: headerRef } = useInView({ threshold: 0.1 })

    const logos = [
      { src: require('@/assets/section4/africell_logo.png'), alt: 'MTN' },
      { src: require('@/assets/section4/orange_logo.png'), alt: 'MTN MoMo' },
      { src: require('@/assets/section4/vodacom_logo.png'), alt: 'Glo' },
      { src: require('@/assets/section4/airtel_logo.jpeg'), alt: 'ADB' },
      // { src: require('@/assets/section4/vodafone_cash.jpg'), alt: 'Vodafone Cash' },
      // { src: require('@/assets/section4/vodafone.jpg'), alt: 'Vodafone' },
      // { src: require('@/assets/section4/airteltigo.jpg'), alt: 'AirtelTigo' },
      //{ src: require('@/assets/section4/more.jpg'), alt: 'Over 200 Entities' },
    ]

    const logoRefs = ref([])
    const logoVisible = ref(Array(logos.length).fill(false))

    const getAnimationClass = (index) => {
      const isLeft = index % 4 < 2
      return isLeft ? `slide-left delay-${index % 3}` : `slide-right delay-${index % 3}`
    }

    onMounted(() => {
      logoRefs.value.forEach((el, index) => {
        if (!el) return

        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              logoVisible.value[index] = true
              observer.unobserve(el)
            }
          },
          {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
          }
        )

        observer.observe(el)
      })
    })

    return {
      logos,
      headerVisible,
      headerRef,
      logoVisible,
      logoRefs,
      getAnimationClass
    }
  }
}
</script>
<style scoped>
.section4 {
  padding: 5rem 1rem;
  width: 100vw;
  background-color: #f7f9fb;


}

.section4-header {
  margin-bottom: 3rem;
  width: 100%;
  padding: 0 1rem;
}

.badge {
  background: #000c7a;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  text-transform: uppercase;
  display: inline-block;

}

.title {
  font-size: 2.2rem;
  font-weight: 700;
  color: #2c3e50;
  margin-top: 1rem;
}

.underline {
  width: 80px;
  height: 4px;
  background: #42b983;
  margin: 1rem auto;
  border-radius: 2px;
}

/* Grille */
.logo-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  width: 100%;
  margin: 0 auto;
  padding: 0 1rem;
}

/* Carte de logo */
.logo-card {
  background: white;
  height: 280px;
  width: 340px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
  overflow: hidden;
}

.logo-img {
      margin-left: 5%;

  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.logo-card:hover {
  transform: scale(1.03);
}

.logo-card:hover .logo-img {
  transform: scale(1.1);
}

/* === Animations === */
.animated {
  opacity: 0;
  transform: translateX(0);
  animation-duration: 0.9s;
  animation-fill-mode: forwards;
  animation-timing-function: cubic-bezier(0.65, 0, 0.35, 1.5);
}

.slide-left {
  transform: translateX(-120px);
  animation-name: slideInLeft;
}

.slide-right {
  transform: translateX(120px);
  animation-name: slideInRight;
}

@keyframes slideInLeft {
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInRight {
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Delays - version lente pour meilleure appréciation */
.delay-0 { animation-delay: 0.6s; }
.delay-1 { animation-delay: 1.2s; }
.delay-2 { animation-delay: 1.8s; }
.delay-3 { animation-delay: 2.4s; }
.delay-4 { animation-delay: 3s; }
.delay-5 { animation-delay: 3.6s; }
.delay-6 { animation-delay: 4.2s; }
.delay-7 { animation-delay: 4.8s; }

/* Responsive */
@media (max-width: 991px) {
  .logo-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .logo-grid {
    grid-template-columns: 1fr;
  }

  .logo-card {
    height: 140px;
  }

  .title {
    font-size: 1.8rem;
  }
}
</style>
